import { TypeAsnSource } from '../../interfaces/Asn/TypeAsnSource'
import {
  GET_TYPE_ASN_SOURCE_EXITO,
  GET_TYPE_ASN_SOURCE
} from '../types/typeAsnSourceActionsTypes'

export type TypeAsnSourceAction =
  | TypeAsnSourcesAction
  | TypeAsnSourcesActionAsync

// Esto va a REDUX
export interface TypeAsnSourcesAction {
  type: typeof GET_TYPE_ASN_SOURCE_EXITO
  typeAsnSource: TypeAsnSource[] | undefined
  error: string | undefined
}

export const getTypesAsnSourceAction = (
  typeAsnSource?: TypeAsnSource[],
  error?: string
): TypeAsnSourcesAction => {
  return {
    type: GET_TYPE_ASN_SOURCE_EXITO,
    typeAsnSource: typeAsnSource,
    error
  }
}

// Esto va a SAGA
export interface TypeAsnSourcesActionAsync {
  type: typeof GET_TYPE_ASN_SOURCE
}

export const getTypesAsnSourceActionAsync = (): TypeAsnSourcesActionAsync => {
  return {
    type: GET_TYPE_ASN_SOURCE
  }
}
